import React, {ReactNode} from 'react';

export function HTMLTag({type, children, ...props}: {type: string; children: ReactNode; [prop: string]: any}) {
  return React.createElement(type, props, children);
}
